import React, { useState, useEffect } from 'react';
import { auth, db } from '../Firebase';
import { doc, getDoc } from 'firebase/firestore';
import Navbar from '../components/Navbar';
import Clocking from '../pages/Clocking';
import ContactUs from '../pages/ContactUs';
import { Box, useMediaQuery, Typography } from '@mui/material';
import AdminClockingReport from '../pages/AdminClockingReport';
import AdminAnalytics from '../pages/AdminAnalytics';
import AdminSitesMap from '../pages/AdminSitesMap';


function Home() {

  const [userRole, setUserRole] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const sidebarWidth = 283;


  useEffect(() => {
    const fetchUserRole = async () => {
      const user = auth.currentUser;
      if (user) {
        const docRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const role = docSnap.data().role;
          setUserRole(role);
  
          if (role === 'admin') {
            setCurrentPage('AdminClockingReport');
          } else {
            setCurrentPage('Clocking');
          }
        }
      }
    };
  
    fetchUserRole();
  }, []);

  

  return (
    <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', height: '100vh', overflow: 'hidden' }}>

      {/* Navbar */}
      <Box
        sx={{
          width: isMobile ? '100%' : `${sidebarWidth}px`,
          flexShrink: 0,
        }}
      >
        <Navbar onPageChange={setCurrentPage} />
      </Box>

      {/* Page Content */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          height: '100vh',
          p: 1,
          pt: isMobile ? '64px' : undefined, // offset topbar
          backgroundColor: '#f7f7f7',
          boxSizing: 'border-box',
        }}
      >
        {currentPage === 'Clocking' && <Clocking />}
        {currentPage === 'Contact' && <ContactUs />}
        {currentPage === 'AdminClockingReport' && <AdminClockingReport />}
        {currentPage === 'AdminSitesMap' && <AdminSitesMap />}
        {currentPage === 'AdminAnalytics' && <AdminAnalytics />}
      </Box>
    </Box>
  );
}

export default Home;
